/**
 * @file coordinate-utils.ts
 * @description Provides utilities for viewport-to-document coordinate transformation on the canvas.
 */

import { g } from '@hcie/core';

/**
 * @function updateMouseCoordinates
 * @description Maps the browser viewport coordinates from a MouseEvent to the internal canvas document coordinates.
 * @param {MouseEvent} event - The mouse event providing viewport coordinates.
 * @returns {void}
 */
export function updateMouseCoordinates(event: MouseEvent): void {
    // [CRITICAL_LOGIC_START]
    const drawingCanvas = document.getElementById("drawingCanvas") as HTMLCanvasElement;
    if (!drawingCanvas) {
        return;
    }

    const canvasRect: DOMRect = drawingCanvas.getBoundingClientRect();
    
    // STEP 1: Resolution Scaling
    // Account for internal canvas resolution vs displayed screen resolution (CSS).
    const resolutionScaleX: number = drawingCanvas.width / canvasRect.width;
    const resolutionScaleY: number = drawingCanvas.height / canvasRect.height;
    
    // STEP 2: Coordinate Translation
    // rect.left/top takes zoom into account for CSS positioning. 
    // We scale the offset to map back to original 1:1 document pixels.
    // NOTE: Do not divide by g.zoom here, as scaleX/Y already covers it.
    g.pX = (event.clientX - canvasRect.left) * resolutionScaleX;
    g.pY = (event.clientY - canvasRect.top) * resolutionScaleY;
    
    // [DEBUG 2026-04-07][TaskID: CoordinateSync] Mapped event:[${event.clientX}, ${event.clientY}] to Doc:[${Math.round(g.pX)}, ${Math.round(g.pY)}]
    // [CRITICAL_LOGIC_END]
}
